import { getZignalyThemeExport } from '@zignaly-open/ui';

const mui = getZignalyThemeExport('dark');

export default mui;
